import { createSlice } from '@reduxjs/toolkit'

export const onLoadProductsReducer = (state, { payload }) => {
  const { products } = payload

  const newState = {
    ...state,
    products
  }
  return newState
}

export const onLoadKitsReducer = (state, { payload }) => {
  const { kits } = payload

  const newState = {
    ...state,
    kits
  }
  return newState
}

export const onLoadBitsReducer = (state, { payload }) => {
  const { bits } = payload

  const newState = {
    ...state,
    bits
  }
  return newState
}

export const onLoadPacksReducer = (state, { payload }) => {
  const { packs } = payload

  const newState = {
    ...state,
    packs
  }
  return newState
}

export const onLoadBotsReducer = (state, { payload }) => {
  const { bots } = payload

  const newState = {
    ...state,
    bots
  }
  return newState
}

const activitySlice = createSlice({
  name: 'product',
  initialState: {
    products: [],
    kits: [],
    bits: [],
    packs: [],
    bots: []
  },
  reducers: {
    onLoadProducts: onLoadProductsReducer,
    onLoadKits: onLoadKitsReducer,
    onLoadBits: onLoadBitsReducer,
    onLoadPacks: onLoadPacksReducer,
    onLoadBots: onLoadBotsReducer
  }
})

const { actions, reducer } = activitySlice

export const {
  onLoadProducts,
  onLoadKits,
  onLoadBits,
  onLoadBots,
  onLoadPacks
} = actions

export default reducer
